import server from '../../api/server';

export class GetConsultObjectivesService {
    static async getObjectives(token: string): Promise<any> {
        const headers = {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        };

        try {
            const responseServer = await server.get(
              `staff/nutrition-objective`,
              {headers}
            );

            if (responseServer.data.statusCode != 200) {
                console.log("ERROR");
            }

            return responseServer.data.data;
        } catch (error: any) {
            throw new Error(error.response.status);
        }
    }
}
